/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Toast_Failed_To_Respond_To_InvitationInputs */

const en_toast_failed_to_respond_to_invitation = /** @type {(inputs: Toast_Failed_To_Respond_To_InvitationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to respond to invitation`)
};

const nl_toast_failed_to_respond_to_invitation = /** @type {(inputs: Toast_Failed_To_Respond_To_InvitationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reageren op uitnodiging mislukt`)
};

/**
* | output |
* | --- |
* | "Failed to respond to invitation" |
*
* @param {Toast_Failed_To_Respond_To_InvitationInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const toast_failed_to_respond_to_invitation = /** @type {((inputs?: Toast_Failed_To_Respond_To_InvitationInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Toast_Failed_To_Respond_To_InvitationInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_toast_failed_to_respond_to_invitation(inputs)
	return en_toast_failed_to_respond_to_invitation(inputs)
});